export const CONSTANTS = {
	RESETALL: Symbol("Checkpoints/ResetAll"),
	ARCHIVED: "archived",
	NOT_ARCHIVED: "not_archived",
	OFF: "off",
	ON: "on",
	SIX_MONTHS: "6",
	TWELVE_MONTHS: "12"
};

const initialState = {
	checkpoints: null,
	checkpoint: null,
	isLoading: {
		all: false,
		pagination: false,
		stats: false,
		selected: false,
		one: false,
		archive: false,
		active: false,
		delete: false
	},
	paginationCkpts: {
		limit: 28,
		offset: 0,
		totalCount: 0
	},
	filterOptions: {},
	search: "",
	submitSuccess: false,
	deleteSucceeded: false,
	showArchived: false,
	next: null,
	prev: null
};

/**
 * Reducer managing checkpoint.
 *
 * @name CheckpointReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		switch (action.type) {
			case CONSTANTS.RESETALL:
				return initialState;
			default:
				return state;
		}
	}
	return action.performCheckpointReducer(state);
};
